import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function AggregatorAddressLine3Form({ aggregatorCity, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line" />
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="city"
          id="city"
          placeholder="City"
          value={aggregatorCity || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(AggregatorAddressLine3Form);
